import { render, staticRenderFns } from "./prestationPopup.vue?vue&type=template&id=3e6d510c&scoped=true&"
import script from "./prestationPopup.vue?vue&type=script&lang=js&"
export * from "./prestationPopup.vue?vue&type=script&lang=js&"
import style0 from "./prestationPopup.vue?vue&type=style&index=0&id=3e6d510c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6d510c",
  null
  
)

export default component.exports